module.exports = __webpack_public_path__ + "img/page_notice.7f25cfe7.png";